'use client'
import { useDialogData } from 'src/context/DialogContext'

export default function DemoButton() {
  const { openDialog } = useDialogData()
  return (
    <button
      className="mx-auto mt-4"
      onClick={openDialog}
      style={{
        width: '11.8rem',
        height: '4rem',
        background: '#DF5F2E',
        borderRadius: '4px',
        fontWeight: 600,
        fontSize: '1rem',
        lineHeight: '1.2rem',
        color: 'white',
      }}
    >
      Book a Demo
    </button>
  )
}
